<template>
  <UiForm class="captcha-form" ref="formWrapper" @submit="(e) => submit(e)">
    <div class="captcha-form-top">
        <div class="captcha-form-image">
            <img width="180" height="50" v-show="!imageLoading" @load="onLoad" :src="`${image}?t=${cacheKey}`">
            <span>Загрузка...</span>
        </div>
        <UiButton
        type="button"
        @click="resetCaptcha"
        >
            <v-icon icon="mdi-reload" />
        </UiButton>
    </div>
    <UiField
      label="Введите каптчу"
      v-model="captchaValue"
    />
    <UiButton
      class="w-100"
      type="submit"
      icon-after="mdi-arrow-right"
      :disabled="!captchaValue"
    >Отправить</UiButton>
  </UiForm>
</template>

<script>
import { ref, watch, computed, inject, onMounted } from 'vue'
import UiField from '@/components/ui/UiField.vue'
import UiForm from '@/components/ui/UiForm.vue'
import UiButton from '@/components/ui/UiButton.vue'

export default {
  components: {
    UiField,
    UiForm,
    UiButton,
  },
  emits: ['submit'],

  props: {
  },
  
  setup(props, {emit}) {
    const image = ref(process.env.VUE_APP_API_URL + '/api/v1/captcha/image')
    const captchaValue = ref('')
    const cacheKey = ref(Date.now())
    const imageLoading = ref(false)
    return {
        image,
        captchaValue,
        cacheKey,
        imageLoading,
        submit: (e) => {
            if (e) {
                e.preventDefault()
            }
            emit('submit', captchaValue.value)
        },
        onLoad: () => {
            imageLoading.value = false
        },
        resetCaptcha: () => {
            imageLoading.value = true
            cacheKey.value = Date.now()
        }
    }
  }
}
</script>

<style lang="scss">
.captcha-form {
    &-image {
        width: 180px;
        height: 50px;
        position: relative;
        img {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 1;
        }
        span {
            position: absolute;
            width: 100%;
            height: 100%;
            text-align: center;
            left: 0;
            line-height: 50px;
        }
    }
    &-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
    }
}
</style>

